var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 300 300.3",
  style: {
    enableBackground: "new 0 0 300 300.3"
  },
  xmlSpace: "preserve"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0x\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "st0x",
  d: "M178.6,127.2L290.3,0h-26.5l-97,110.4L89.3,0H0l117.1,166.9L0,300.2h26.5l102.4-116.6l81.8,116.6H300 M36,19.5 h40.7l187.1,262.1h-40.7"
})));
export default SvgXLogo;